import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.page.html',
  styleUrls: ['./favorites.page.scss'],
})
export class FavoritesPage implements OnInit {
  public products: any[] = [];
  public page: number = 1;
  public totalPages: number = 1;
  public loaded = false;

  constructor(
    private httpSv: HttpService
  ) { }

  ngOnInit() {
    this.getProducts();
  }

  async getProducts(){
    try{
      this.httpSv.loadingIndicatorSrc.next(true);
      const res = await this.httpSv.itemIndex('productFavorite', this.page);
      this.httpSv.loadingIndicatorSrc.next(false);
      const data = res.data;
      this.products = data.data;
      this.loaded = true;
      this.totalPages = data.meta.last_page;
    }catch(err){
      console.error(err);
    }
  }

  upPage(page){
    this.page = page;
    this.getProducts();
  }

}
